import { render } from "./myEmpty.vue?vue&type=template&id=5206bb66&scoped=true&ts=true&lang=pug"
import script from "./myEmpty.vue?vue&type=script&lang=ts"
export * from "./myEmpty.vue?vue&type=script&lang=ts"

import "./myEmpty.vue?vue&type=style&index=0&id=5206bb66&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5206bb66"]])

export default __exports__